//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        onChange (e) {
            this.$emit('change', e.currentTarget.dataset.key)
    }
    },
    props: {
        scroll: {
            type: Boolean,
            default: false
        },
        width: {
            type: String
        },
        tabs: {
            type: Array,
            validator (value) {
                if (value.length) {
                    return value.every(({ key, name }) => {
                        return key != undefined && name != undefined
                    })
                }
                return true
            }
        },
        selected: {
            type: [ String, Number ]
        }
    }
}
